import { z } from 'zod';

export interface ExecutionToggles {
  includePerpetualSpread: boolean;
  includeVolSpread: boolean;
  includePerpetualFee: boolean;
  includeOptionsFee: boolean;
  whenExecutionWeekdays: boolean;
  whenExecutionAverageIn: boolean;
  optionsNotionalScaled: boolean;
}

export const createExecutionSchema = (toggles: ExecutionToggles) =>
  z.object({
    executionTime: z.string().min(1, 'Execution time is required'),

    whenExecutionWeekdays: z.boolean(),
    whenExecutionWeekdaysDays: toggles.whenExecutionWeekdays
      ? z.array(z.string()).min(1, 'Select at least one day')
      : z
          .array(z.string())
          .optional()
          .transform((v) => v ?? []),
    whenExecutionWeekdaysTime: z
      .string()
      .optional()
      .transform((v) => v ?? ''),
    whenExecutionAverageIn: z.boolean(),
    whenExecutionAverageInIncludeWeekends: z.boolean(),

    optionsNotionalScaled: z.boolean(),
    notionalScalingType: toggles.optionsNotionalScaled
      ? z.string().min(1, 'Notional scaling type is required')
      : z
          .string()
          .optional()
          .transform((v) => v ?? ''),

    includePerpetualSpread: z.boolean(),
    perpetualSpread: toggles.includePerpetualSpread
      ? z.string().min(1, 'Perpetual spread is required')
      : z
          .string()
          .optional()
          .transform((v) => v ?? ''),

    includeVolSpread: z.boolean(),
    volSpread: toggles.includeVolSpread
      ? z.string().min(1, 'Vol spread is required')
      : z
          .string()
          .optional()
          .transform((v) => v ?? ''),

    includePerpetualFee: z.boolean(),
    perpetualFee: toggles.includePerpetualFee
      ? z.string().min(1, 'Perpetual fee is required')
      : z
          .string()
          .optional()
          .transform((v) => v ?? ''),

    includeOptionsFee: z.boolean(),
    optionsFee: toggles.includeOptionsFee
      ? z.string().min(1, 'Options fee is required')
      : z
          .string()
          .optional()
          .transform((v) => v ?? ''),

    convertPerpCashflowToUsd: z.boolean(),
    optionsSettleInUsd: z.boolean(),
    convertFundingCashflowsToUsd: z.boolean(),
    closeStructureOnFirstExpiry: z.boolean(),
    executeTradesOnlyOnce: z.boolean(),

    useExchangeStrikes: z.boolean(),
    exchangeTimeProjection: z.string(),
    exchangeStrikeProjection: z.string(),
  });

export type ExecutionSchemaType = z.infer<ReturnType<typeof createExecutionSchema>>;
